import React from 'react'

type Props = JSX.IntrinsicElements['a'] & {
    openInNewWindow?: boolean
    dataPointer?: string
}

/**
 * ExternalLink
 */
function ExternalLink(props: Props) {
    const { children, dataPointer, openInNewWindow = true, ...restProps } = props
    return (
        <a
            rel="noreferrer noopener"
            target={openInNewWindow ? '_blank' : '_self'}
            {...restProps}
            className={props.className}
            data-pointer={dataPointer}
        >
            {children}
        </a>
    )
}

export default ExternalLink
